import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const TagIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17 5.5a1.5 1.5 0 0 1 0 3 1.5 1.5 0 0 1 0-3Z" />
    <path
      fillRule="evenodd"
      d="M21 1a2 2 0 0 1 2 2v8.6c0 .5-.2 1-.6 1.4l-9 9a3.4 3.4 0 0 1-4.8 0L2 15.4a3.4 3.4 0 0 1 0-4.8l9-9a2 2 0 0 1 1.4-.6H21Zm0 2h-8.6l-9 9c-.5.5-.5 1.5 0 2l6.6 6.6c.5.5 1.5.5 2 0l9-9V3Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default TagIcon;
